import React from 'react'
import { Link } from 'gatsby'
import { Columns, Column } from 'react-flex-columns'
import Heading from 'shared/ui/Heading'
import Icon from 'shared/ui/Icon'
import Avatar from './Avatar'
import team from '../data/team'

export default function TeamBio({ id, url }) {
  const teamMember = team.find((t) => t.id === id)
  if (!teamMember) {
    console.error(`Cannot find Team Member ID: ${id}`)
    return null
  }

  return (
    <div className="spacing">
      <Columns gutters middle>
        <Column>
          <Avatar src={teamMember.avatarUrl} alt={`${teamMember.name} Avatar`} />
        </Column>
        <Column flex>
          <Heading as="h3" size={3}>
            {url ? <Link to={url}>{teamMember.name}</Link> : teamMember.name}
          </Heading>
        </Column>
        <Column>
          <a href={`https://twitter.com/${teamMember.twitterHandle}`} className="icon-text">
            <Icon name="twitter" />
            <span>{teamMember.twitterHandle}</span>
          </a>
        </Column>
      </Columns>
      <div className="spacing">{bios[id]}</div>
    </div>
  )
}

export const bios = {}

bios['cassidy-williams'] = (
  <p>
    Cassidy is a brilliant and entertaining software engineer currently working at Netlify. She's
    previously worked for CodePen, Amazon, and Venmo, and she runs{' '}
    <a href="https://cassidoo.co/newsletter/">technical newsletters</a> for millions of developers
    around the world. She's active in the developer community and one of Glamour Magazine's 35 Women
    Under 35 Changing the Tech Industry and LinkedIn's Top Professionals 35 &amp; Under. She also
    loves playing music, building mechanical keyboards, and telling jokes.
  </p>
)

bios['michael-jackson'] = (
  <p>
    Michael is a prolific software engineer and mentor specializing in React. He is the co-author of
    the popular <a href="https://reactrouter.com/">React Router</a> library and creator of{' '}
    <a href="https://unpkg.com/">UNPKG</a>. He's worked at startups in Silicon Valley, Twitter, and
    been in Y Combinator—all places where he's learned the needs of software development teams like
    yours. Since 2015, he has focused on helping others master React through workshops, online
    videos, articles, and conference talks.
  </p>
)

bios['ryan-florence'] = (
  <p>
    Ryan started making websites for a local ISP before JavaScript or CSS were created. He’s worked
    at agencies, startups, and consulted for Fortune 500 companies. He’s the co-author of{' '}
    <a href="https://reactrouter.com/">React Router</a> and creator of{' '}
    <a href="https://reach.tech/">Reach UI</a>, where his mission is to make React the most
    accessible web ecosystem available. Since 2015, he's been teaching React in countless workshops
    to thousands of developers for top brands and small companies across the world.
  </p>
)

bios['brad-westfall'] = (
  <p>
    Brad has been teaching Web Development since 2010 including bootcamp instruction, online videos,
    conference speaking, writing at{' '}
    <a href="https://css-tricks.com/author/bradwestfall/">CSS-Tricks</a>, and corporate training for
    React. He loves to connect with students by helping them achieve their technical goals and by
    distilling complex concepts into simple instruction.
  </p>
)

bios['chance-strickland'] = (
  <p>
    Chance is a front-end engineer who specializes in creating accessible user interfaces on the
    web. Since 2010, he has worked for various agencies, startups, and himself as an independent
    contractor. He previously worked at Modulz as a co-author of the{' '}
    <a href="https://radix-ui.com/primitives/docs/overview/introduction">Radix UI</a> library and
    currently maintains <a href="https://reach.tech/">Reach UI</a>. He now focuses on education and
    teaching React fundamentals and advanced concepts to teams all over the world.
  </p>
)

bios['james-long'] = (
  <p>
    James Long is a developer & designer with over a decade of experience building large-scale
    applications. He created <a href="https://prettier.io/">Prettier</a>, the de facto standard
    JavaScript code formatting tool. He also led a long-term effort to port Firefox developer tools
    to React at Mozilla, is founder of Actual, and explores new ideas for programming through blog
    posts. He focuses on solving real problems for users with a great user experience.
  </p>
)

bios['david-khourshid'] = (
  <p>
    David Khourshid is a Microsoft software engineer with a passion for innovative user interfaces,
    animations, software modeling, and cutting-edge front-end technologies. He's the creator of{' '}
    <a href="https://xstate.js.org/">XState</a>, a library that brings finite state machines and
    statecharts to the modern web in React (and any other framework) and enables app logic to be
    visualized, simulated, tested, analyzed, and more. He's also half of the{' '}
    <a href="https://www.youtube.com/channel/UCtmYk7H-NNYLEe_LgBRYomA">Keyframers</a>, a weekly
    coding live-stream where imaginative user interfaces are brought to life. When not speaking
    around the world or coding behind a laptop keyboard, he's usually behind a piano keyboard.
  </p>
)
